module.exports = __webpack_public_path__ + "img/Delete.a321baa5.svg";